import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import IconButton from '@mui/material/IconButton';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import profilePhoto from '../../images/profilePhoto.png'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';


export default function EmployerCandidateCard() {
  return (
    <>
    <Box className='EmployerCandidateBox' sx={{ bgcolor:'#c4d1e8',}}>
        <Box px={4} py={2}>
        <Box sx={{
            width:'100%',
           
            justifyContent:'end',
            display:'flex'

        }}>
        <IconButton  size="large" sx={{bgcolor:'#fff', '&:hover': {  backgroundColor: '#FFF', } }}>
        <BookmarkBorderIcon fontSize="inherit" />
      </IconButton>
        </Box>
        <Box textAlign={'center'} mt={2}>
                 <Box >
                    <img src={profilePhoto} alt="img" style={{ height: '100px', width: '100px', borderRadius: '20px' }} />
                  </Box>
                  <Typography className='candidateName'>Anuj Sharma</Typography>
                  <Typography className='candidateDesignation'>Product Designer at Google INC</Typography>
        </Box>
        <Box sx={{display:'flex', justifyContent:'space-between', mt:3}}>
        <Button className='candidateButton' sx={{bgcolor:'#2544EE', '&:hover': {  backgroundColor: '#FFF', } }} variant="contained" endIcon={<KeyboardArrowRightIcon />}>
        Hire Me
      </Button>
        <Button className='candidateButton' sx={{bgcolor:'#fff', color:'#2544EE',  '&:hover': {  backgroundColor: '#FFF', }}} variant="contained" endIcon={<KeyboardArrowRightIcon />}>
        Download CV
      </Button>
        </Box>
        </Box>
    </Box>
    </>
  )
}
